import React from 'react';

import { H4, S } from 'components/typography';

import { useLabels } from '../../i18n/useLabels';
import type { TemplateCustomizationViewModel } from '../../viewmodels/createTemplateCustomizationViewModel';
import { SectionAccordion } from '../sections/SectionAccordion';

import styles from './QuestionsPanel.scss';

type Props = {
  viewModel: Pick<TemplateCustomizationViewModel, 'sections' | 'emptyMessage'>;
};

export function QuestionsPanel({ viewModel }: Props) {
  const labels = useLabels();

  return (
    <div className={styles.panel}>
      <H4>{labels.questionsHeading}</H4>
      {viewModel.sections.map(section => (
        <SectionAccordion key={section.id} viewModel={section} />
      ))}
      {viewModel.emptyMessage && (
        <S variant="secondary">
          {labels.formatMessage(viewModel.emptyMessage)}
        </S>
      )}
    </div>
  );
}
